import { useNavigate } from "react-router-dom";
import BackgroundLayer from "../components/BackgroundLayer";
import CasesList from "../components/CasesList";
import StatusBar from "../components/StatusBar";
import { useCurrentUser } from "../lib/auth";
import { useLex } from "../lib/theme/ThemeProvider";
import Wordmark from "../components/Wordmark";

const buildVersion = import.meta.env.VITE_BERSERKR_BUILD_VERSION ?? "0.0.0-dev";

/**
 * The landing surface - operator greeting + active campaigns list.
 * Click a case to enter its War Room.
 */
function CommandSurface() {
  const user = useCurrentUser();
  const navigate = useNavigate();
  const lex = useLex();
  const firstName = user?.name?.split(/\s+/)[0] ?? "operator";

  return (
    <div className="relative min-h-screen text-bone">
      <BackgroundLayer variant="modes" overlay="heavy" />
      <StatusBar />

      <main className="relative z-10 mx-auto flex min-h-[calc(100vh-2.5rem)] max-w-5xl flex-col px-6 pb-24 pt-20">
        <header className="mb-12 text-center">
          <Wordmark size="lg" className="mb-6 justify-center" />
          <p className="mb-3 font-display text-lg font-light uppercase tracking-[0.18em] text-bone-mute">
            command surface // v{buildVersion}
          </p>
          <h1
            className="font-display text-3xl font-light leading-tight tracking-tight md:text-4xl"
            style={{ textShadow: "0 2px 24px rgba(0,0,0,0.7)" }}
          >
            <span className="text-bone">{lex.greetingPre}</span>
            <span className="text-ember-bright capitalize">{firstName}</span>
            <span className="text-bone">{lex.greetingPost}</span>
          </h1>
        </header>

        <section className="mx-auto w-full max-w-3xl">
          <div className="mb-6 flex items-center justify-between">
            <p className="font-display text-lg font-light uppercase tracking-[0.16em] text-bone-mute">
              {lex.intakeLabel}
            </p>
            <button
              type="button"
              onClick={() => navigate("/upload")}
              className="border border-ember-bright/60 bg-ember/30 px-5 py-2 font-display text-lg font-light uppercase tracking-[0.16em] text-bone transition-colors hover:bg-ember/50 hover:shadow-ember-soft"
            >
              {lex.intakeCta}
            </button>
          </div>
          <CasesList />
        </section>

        <p
          className="mx-auto mt-auto pt-16 font-display text-lg font-light uppercase tracking-[0.16em] text-bone-mute/60"
          style={{ textShadow: "0 1px 8px rgba(0,0,0,0.8)" }}
        >
          {lex.footerLine}
        </p>
      </main>
    </div>
  );
}

export default CommandSurface;
